<template>
    <div  v-loading="submitLoading"
     style="height: 100%;padding-bottom: 20px;background-color:#fff;">
        <div class="title">
    <strong  @click="$router.go(-1)" style="cursor:pointer"><i class="el-icon-back"></i></strong>
    <span >创建套餐</span>
    <span style="margin-left: 10px;font-size: 14px;color: #999;">根据套餐售卖价和菜品原价，自动计算出套餐子菜品的单价</span>
</div>
    <!--  -->
    <div class="top-nav">
    <a title="基础信息" >基础信息</a>
    <a title="套餐菜品" >套餐菜品</a>
    <!-- <a title="销售信息" href="#three">销售信息</a> -->
    <a title="点餐端展示" >点餐端展示</a>
        </div>
<!-- 基础信息-->


    <el-row>
    <el-col><div class="base-info"><span class="line" ></span> <span>基础信息</span></div></el-col>
</el-row>
<!-- 表单信息 -->
<el-form :data="tableData" :model="tableData" :rules="rules" ref="tableData" label-width="140px" class="demo-ruleForm">
    <el-form-item :key="1" required label="套餐名称:" prop="productName">
        <el-input @input="getPinYin"  v-model="tableData.productName"></el-input>
    </el-form-item>
    <el-form-item :key="2" required label="套餐分类:" prop="tcfl">
        <el-select @change="changeSel" value-key="categoryCode" clearable v-model="tableData.tcfl" placeholder="请选择">
    <el-option
    v-for="item,i in tcflOptions"
      :label="item.categoryName"
      :value="{categoryCode:item.categoryCode,categoryName:item.categoryName}"
      :key="i"
      >
    </el-option>
  </el-select>
    </el-form-item>
    <el-form-item label="套餐价格:" :key="3">
        <div style="width: 66vw;height: 72px;border: 1px solid #eee;padding: 8px 14px;">
        <el-form inline label-position="top">
            <el-form-item label="基础价格" required class="no-label-padding">
                <el-input class="small-group" placeholder="请输入" v-model="tableData.normalPrice">
                    <span slot="suffix" style="color: #333;margin-right: 6px;">元</span>
                </el-input>
            </el-form-item>
            <el-form-item label="会员价" required class="no-label-padding">
                <el-input  v-model="tableData.memberPrice" class="small-group" placeholder="请输入">
                    <span slot="suffix" style="color: #333;margin-right: 6px;">元</span>
                </el-input>
            </el-form-item>
        </el-form>
        </div>
    </el-form-item>
    <el-form-item label="是否上架小程序:" :key="4">
<el-radio v-model="tableData.isVisible" :label=0 >否</el-radio>
<el-radio v-model="tableData.isVisible" :label=1 >是</el-radio>
    </el-form-item>
    <el-form-item label="拼音助记码:" prop="pinyin" :key="5">
     <el-input v-model="tableData.pinyin" placeholder="请输入拼音助记码，例如：src"></el-input>
    </el-form-item>
    <!-- 套餐菜品-->
<el-row >
    <el-col><div id="two" class="base-info"><span class="line" ></span> <span>套餐菜品</span></div></el-col>
</el-row>
<el-form-item label="菜品信息:" >
    <div style="padding:12px;background-color: #f5f5f5;" v-for="item,i in tableData.comboGroupList" :key="i">
    <div class="dish-header">
        <el-autocomplete
      class="inline-input cpxx"
      v-model="item.comboGroupName"
      :fetch-suggestions="querySearch"
      placeholder="请输入内容"
      @select="handleSelect"
    ></el-autocomplete>
    <el-select v-model="item.comboGroupType" class="cpxx">
        <el-option label="固定分组" value="1">
        </el-option >
        <el-option label="可选分组" value="2">
        </el-option >
    </el-select>
    <div class="bzcp" v-show="item.comboGroupType=='2'&& item.comboList!=null && item.comboList.length!=0"><span>本组菜品{{item.comboList.length}}选</span>
        <input v-model="item.minNum" min="1" type="number" step="1" class="slelct-native-input">
    </div>
    <!-- <el-select class="small-select-type" v-model="item.optionalGroupType" placeholder="请选择">
    <el-option label="按固定值" value="1"></el-option>
    <el-option label="按区间选择" value="2"></el-option>
  </el-select> -->
    <el-checkbox v-show="item.comboGroupType==2 && item.comboList!=null && item.comboList.length!=0" v-model="item.repeatFlag" style="margin-left: 16px;" :disabled="item.minNum>item.comboList.length">可重复选菜品</el-checkbox>
    <span v-if="tableData.comboGroupList.length!=1" @click="deleteOne(i)" 
    style="color: #666;position: absolute;right: 100px;cursor: pointer;"><i class="el-icon-remove-outline"></i>删除分组</span>
    </div>
    <!-- center -->
    <div class="dish-header" v-show="tableData.comboGroupList!=null && tableData.comboGroupList.length!=0">
        <el-table
        ref="item.comboList"
        v-show="item.comboList!=null && item.comboList.length!=0"
      :data="item.comboList"
      :row-key="getRowKeys"
      style="width: 100%">
      <el-table-column label="序号" fixed type="index">
      </el-table-column>
      <el-table-column
        prop="productName"
        label="名称"
        fixed
        >
      </el-table-column>
      <el-table-column
        prop="normalPrice"
        label="菜品销售价"
        >
      </el-table-column>
      <el-table-column
        prop="purchansePrice"
        label="预估成本价">
      </el-table-column>
      <el-table-column v-show="item.comboGroupType==2" label="菜品加价" prop="raisePrice">
        <template slot-scope="scope">
            <el-input class="number-input" v-model="scope.row.raisePrice"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="数量" prop="num">
        <template slot-scope="scope">
            <el-input-number  controls-position="right" :min="1" v-model="scope.row.num" class="number-input number-small-input"></el-input-number>
        </template>
      </el-table-column>
      <el-table-column v-if="item.comboGroupType==2" label="必选">
        <template slot-scope="scope">
           <el-checkbox @change="scope.row.defaultStatus1? scope.row.defaultStatus2=false:''" v-model="scope.row.defaultStatus1" value="1"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column v-if="item.comboGroupType==2" label="默认">
        <template slot-scope="scope">
           <el-checkbox @change="scope.row.defaultStatus2? scope.row.defaultStatus1=false:''" v-model="scope.row.defaultStatus2" value="2"></el-checkbox>
        </template>
      </el-table-column>
      <el-table-column  label="操作">
       <template slot-scope="scope">
        <span style="color: #ff6000;cursor: pointer;" @click="deleteShowTable(i,scope.$index)">删除</span>
       </template>
      </el-table-column>
    </el-table>
    </div>
<!-- bottom -->
<div class="dish-header" >
<div class="button" @click="addType(i,item.comboList)">
    <i class="el-icon-circle-plus-outline"></i>
<span>添加菜品</span>
</div>
    </div>
    
</div>
<div @click="addList" 
    >
    <el-button style="background-color: #ffd100;color: #222;margin-top: 10px;">新建分组</el-button>
    </div>
<!--  -->
</el-form-item>
<!-- 销售信息-->
<!-- <el-row>
    <el-col><div id="three" class="base-info"><span class="line" ></span> <span>销售信息</span></div></el-col>
</el-row>
<el-form-item label="售卖状态:">
<el-radio label="1" v-model="tableData.saleStatus">在售</el-radio>
<el-radio label="0" v-model="tableData.saleStatus">停售</el-radio>
</el-form-item> -->


<!-- 点餐端展示-->
<el-row>
    <el-col><div id="four" class="base-info"><span class="line" ></span> <span>点餐端展示</span></div></el-col>
</el-row>
<el-form-item label="菜品图片:">
    <el-upload
  class="avatar-uploader"
  action="https://train.yunlankeji.com/api/upload/uploadFile"
  :show-file-list="false"
  :on-success="handleAvatarSuccess">
  <img v-show="tableData.smallImg" :src="tableData.smallImg" class="avatar">
  <i v-show="!tableData.smallImg" class="el-icon-plus avatar-uploader-icon"></i>
</el-upload>

</el-form-item>
<!-- <el-form-item label="手机点餐端展示">
    <el-radio label="1" v-model="tableData.phoneShowFlag">展示</el-radio>
    <el-radio label="0" v-model="tableData.phoneShowFlag">隐藏</el-radio>
</el-form-item> -->

</el-form>


<!-- 对话 -->
<el-dialog
  title="选择菜品"
  :visible.sync="dialogVisible"
  width="60%"
  >
    <el-input
    class="dialog-search"
    placeholder="请输入菜品名或助记码搜索"
    prefix-icon="el-icon-search"
    v-model="searchDish"
    @keyup.native="debouncedSearch"
    >
  </el-input>
  <div class="dialog-body">
    <div class="left">
      <div :class="{'item': true, 'active' : i==activeIndex}" v-for="item,i in categoryList" @click="seeDetail(i,item.categoryCode)" :title="item.categoryName" :key="i">{{item.categoryName}}</div>
    </div>
    <div class="right">
      <el-table
      :row-key="getRowKeys"
      v-loading="loadingDialog"
       @selection-change="handleSelectionChange"
      :data="tableRight"
      ref="tableRight"
      height="290"
      style="width: 100%">
      <el-table-column type="selection" fixed :reserve-selection="true"></el-table-column>
      <el-table-column
        prop="productName"
        label="菜品名称"
        align="center"
        >
      </el-table-column>
      <el-table-column
        prop="formatDesc"
         align="center"
        label="菜品规格"
        >
      </el-table-column>
      <el-table-column
       align="center"
        prop="normalPrice"
        label="售卖价">
      </el-table-column>
    </el-table>
    </div>
  </div>
  <div style="margin-top: 10px;margin-bottom: 10px;" ><span style="color: #333;">已选择 ({{ selected.length }})</span></div>
  <div style="display: flex;flex-wrap: wrap;width: 90%;">
    <span 
    v-for="item,i in selected"
    :key="i"
    style="margin-bottom: 10px;margin-right: 6px;font-size:12px;border: 1px solid #ccc;padding: 2px 4px;background-color: #fafafa; ">{{ item.productName }}</span>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button style="background-color: #ffbd00;color: #606260;" @click="showTable">确 定</el-button>
  </span>
</el-dialog>
<div class="foot">
       <el-button @click="$router.go(-1)">取消</el-button>
    <el-button type="primary" @click="submit" v-loading.fullscreen.lock="fullscreenLoading">保存并创建</el-button>
</div>

    </div>
</template>
<script >
import { pinyin } from 'pinyin-pro';
export default{
    data(){
        return{
          submitLoading:false,
          fullscreenLoading:"",
            selectType:'',
            rules:{
            tcfl:[ { required: true, message: '请选择分类', trigger: ['blur','change'] }],
            productName:[{required:true,message:'套餐名称必填',trigger:['blur','change']}]
            },
            tcflOptions:[],
            searchDish:'',
            activeIndex:'0',
            selected:[],
            merchantCode:'',
            categoryList:[],
            tableRight:[],//对话框右侧表格
            loadingDialog:true,
            dialogVisible:false,
            tableData:{
                merchantCode:'',
                merchantName:'',
                isCombo:1,//此处值固定
                productName:'',//套餐名称
                categoryName:'',
                categoryCode:"",//类别编码
                normalPrice:'',//正常价格
                memberPrice:'',//会员价格
                tcfl:'',//套餐分类
                pinyin:'', //拼音码
                smallImg:'',// 小图
                isVisible:0,//是否可见
                saleStatus:'1',//售卖状态
                // phoneShowFlag:'1',//手机端点餐展示
                //菜品信息
                comboGroupList:[
                    {
                      sep:"1",
                    minNum:'1',
                    comboGroupName:'',//套餐分组名称
                    comboGroupType:'1',//套餐分组类型
                    optionalGroupType:'',
                    comboList:[],
                    repeatFlag:false
                    }
                ],//菜品分组信息
                sfyytg:'2',
                chsz:'1',
                tcjgft:'1',
                cpxx:'',
                xzfz:'',//选择分组
                
                list:[{}]
            }

        };
    },
    // 
    methods: {
        getRowKeys(row) { //唯一值
				return row.productCode;
			},
        submit(){
          // this.fullscreenLoading = true
          this.submitLoading=true
            this.tableData.categoryCode=this.tableData.tcfl.categoryCode
            this.tableData.categoryName=this.tableData.tcfl.categoryName
            this.tableData.comboGroupList.forEach((item,i)=>{
              item.seq=(i+1) * 1
                item.totalNum=item.comboList.length
                if(item.repeatFlag==true){
                    item.repeatFlag=1
                }else{
                    item.repeatFlag=0
                }
                item.comboList.forEach(i=>{
                    if(i.defaultStatus1==true){
                        i.defaultStatus=1
                    }
                    if(i.defaultStatus2==true){
                        i.defaultStatus=2
                    }
                    if(i.defaultStatus1==false && i.defaultStatus2==false){
                        i.defaultStatus=0
                    }
                })
            })
            this.$http.post('/merchantProducts/saveProductCombo',this.tableData).then(res=>{
              // this.fullscreenLoading = false
              this.submitLoading=false
              if(res.data.code==200){
                  this.$message({
                    type:"success",
                    message:'保存成功'
                  })
                  this.$router.push('/merchantProduct')
                }else{
                  this.$message.error(res.data.message)
                }
            })
        },
        // 文件上传
        handleAvatarSuccess(res,file){
            console.log(res,file)
            this.tableData.smallImg=res.data.url
        },
        addList(){
            this.tableData.comboGroupList.push(
                {
                    minNum:'1',
                    comboGroupName:'',//套餐分组名称
                    comboGroupType:'1',//套餐分组类型
                    optionalGroupType:'',
                    comboList:[],
                    repeatFlag:false
                    }
            )
        },
        deleteOne(i){
            this.tableData.comboGroupList.splice(i,1)
        },

        deleteShowTable(i,index){
           this.tableData.comboGroupList[i].comboList.splice(index,1)
        },
        // 赋值
      showTable(){
        var arr=[]
        this.selected.forEach(item=>{
          var data={}
          data.id=item.id
          data.productCode=item.productCode
          data.productName=item.productName
          data.formatDesc=item.formatDesc
          data.normalPrice=item.normalPrice
          data.saleNum=''
          data.num='1'
          data.raisePrice=''
          data.defaultStatus1=''
          data.defaultStatus2=''
          data.categoryCode=item.categoryCode
          data.categoryName=item.categoryName
          data.unit=item.unit
          data.pinyin=item.pinyin
          data.isVisible=item.isVisible
          data.stock=item.stock
          arr.push(data)
        })
        console.log(arr)
        this.tableData.comboGroupList[this.selectType].comboList=arr
        this.dialogVisible=false
      },
        seeDetail(i,code){
        this.activeIndex=i
        this.$http.post('/merchantProducts/queryList',{merchantCode:this.merchantCode,categoryCode:code}).then(res=>{
          this.tableRight=res.data.data
        })
      },
        handleSelectionChange(val){
        this.selected=val
      },
      //添加菜品
        addType(i,item){
        console.log(i,item,'添加菜品')
        this.selectType=i
// 
  if(item!=null && item.length>0 ){
     setTimeout(() => {
    console.log(this.$ref,this.$refs.tableRight)
    this.$refs.tableRight.clearSelection();
    item.forEach(it=>{
    this.$refs.tableRight.toggleRowSelection(it,true);
    })
}, 0);
}else{
setTimeout(() => {
    console.log('清空')
    this.$refs.tableRight.clearSelection()
}, 0);
}
        // 
        this.dialogVisible=true
          this.$http.post('/merchantProductsCategory/queryList',{merchantCode:this.merchantCode,isCombo:0}).then(res=>{
          this.categoryList=res.data.data
          this.categoryList.unshift({categoryCode: "",categoryName: "全部分类"})
          this.categoryCode=res.data.data[0].categoryCode
          this.seeDetail(0,this.categoryCode)
          this.loadingDialog=false
        })
        },
        // 套餐分类下拉框
        getTypes(){
            this.$http.post('/merchantProductsCategory/queryList',{merchantCode:localStorage.getItem('merchantCode')}).then(res=>{
                this.tcflOptions=res.data.data
            })
        },
        // 
      querySearch(queryString, cb) {
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      loadAll() {
        return [
          { "value": "热菜",  },
          { "value": "凉菜", },
          { "value": "主食",  },
          { "value": "饮料", },
          { "value": "小吃",},
        ];
      },
      handleSelect(item) {
        console.log(item);
      },
      getPinYin(){
        this.tableData.pinyin=pinyin(this.tableData.productName, { pattern: 'first' }).replace(/\s+/g, '')
      },
      changeSel(val){
  this.$nextTick(() => {
    this.$forceUpdate()
    })

      },
      queryOne(){
        this.submitLoading=true
        console.log('开loading1')
        this.$http.post('/merchantProducts/queryOne',{id:this.$route.query.id,isCombo:this.$route.query.isCombo,productCode:this.$route.query.productCode,merchantCode:localStorage.getItem('merchantCode')}).then(res=>{
            console.log(res,'回显')
            this.tableData=res.data.data
            this.submitLoading=false
            this.tableData.tcfl={categoryCode:res.data.data.categoryCode,categoryName:res.data.data.categoryName}
            this.tableData.comboGroupList.forEach(item=>{
                if(item.repeatFlag==1){
                    item.repeatFlag=true
                }else{
                    item.repeatFlag=false
                }
                item.comboList.forEach(i=>{
                    if(i.defaultStatus==1){
                        i.defaultStatus1=true
                    }
                    if(i.defaultStatus==2){
                        i.defaultStatus2=true
                    }
                    if(i.defaultStatus==null || i.defaultStatus==''|| i.defaultStatus==0 ){
                        i.defaultStatus1=false
                        i.defaultStatus2=false
                    }
                })
            })
        })
      }
    },
    mounted() {
      this.restaurants = this.loadAll();
    },
    // 

    // 
    created () {
        this.merchantCode=localStorage.getItem('merchantCode')
        this.tableData.merchantCode=localStorage.getItem('merchantCode')
        this.tableData.merchantName=localStorage.getItem('merchantName')
       if(this.$route.query.productCode){
        this.queryOne()
       }
        this.getTypes()
    }
    
}
</script>

<style lang="less" scoped>
.top-nav{
    width: 100%;
    background-color: #fff;
    margin-left: 20px;
    color: #333;
    font-size: 14px;
    a{
        cursor: pointer;
        display: inline-block;
        width: 80px;
        height: 32px;
        line-height: 32px;
    }
    a:hover{
        color: #f59a23;
    }
}
/deep/.number-input{
   .el-input__inner{
    width: 90%;
   }
}
// 展开更多设置
.seemore:hover{
border-bottom: 1px solid #ff6000;
cursor: pointer;
}
.title{
    padding: 6px 10px;
    height: 36px;
    border-bottom: 2px solid #f6f6f6;
    display: flex;
    align-items: center;
    span{
        margin-left: 10px;
    }
    i,span{
      font-size: 20px;
    font-weight: 500;
    }
}
.line {
        display: inline-block;
        width: 3px;
        height: 15px;
        background-color: orange;
        margin-right: 5px;
        border-radius: 2px;
        margin-bottom: -2px;
    }
    .base-info{
        margin: 30px 0px 10px 20px;
    }
/deep/.el-select{
width: 220px;
    }
    /deep/.el-input__inner{
        width: 220px;
    }

    /deep/.small-group .el-input__inner{
        width: 130px;
    }
    /deep/.no-label-padding .el-form-item__label{
        padding: 0;
    }

    .dish-header{
    position: relative;
    display: flex;
    align-items: flex-start;
    background-color: #fff;
    border-bottom: 1px solid #e8e8e8;
    padding: 8px 90px 8px 16px;
    flex-wrap: wrap;
    .button{
    cursor: pointer;
    width: 100%;
    text-align: left;
    color: #ff6000;
    user-select: none;
    height: 24px;
    line-height: 24px;
    padding: 5px 16px;
    font-size: 14px;
    border-radius: 4px;
    background: #fff;
    border: 1px dashed #d9d9d9;
    font-weight: 500;
    span{
        margin-left: 7px;
    }
    }
    }
    /deep/.cpxx{
        width: 120px;
        .el-input__inner{
            width: 110px;
        }
    }
    /deep/ .el-select.cpxx.el-select--small{
        width: 110px;
    }

    /deep/ .dialog-body{
  display: flex;
  margin-top: 20px;
  padding-left: 10px;
  border-bottom: 1px solid #ccc;
  .left{
    border-right: 1px solid #e8e8e8;
    padding: 12px;
    width: 22%;
    padding-top: 16px;
    height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
    margin-right: 10px;
    .item{
      height: 24px;
      line-height: 24px;
      cursor: pointer;
      width: 85%;
      padding: 0 8px;
      margin-bottom: 7px;
      color: #333;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .item:hover{
      background: rgba(246,246,246);
    }
    .item.active{
      background-color: rgba(255,189,0,.2);
    }
  }
  .right{
    // margin-left: 10px;
    width: 78%;
  }

}

/deep/ .right .el-table-column--selection .cell{
  padding-left: 10px;
}
/deep/ .dialog-search{
    .el-input__inner{
    width: 98% ;
  }
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  .avatar {
    width: 80px;
    height: 80px;
    display: block;
  }
  /deep/ .el-upload{
    border: 1px dashed rgba(0,0,0,.15);
  }
  /deep/ .el-radio__input.is-checked .el-radio__inner{
    border-color: #f59a23;
    background-color: #f59a23;
  }
  /deep/ .el-radio__input.is-checked+.el-radio__label{
    color: #606266;
  }
  /deep/ .el-form-item__label{
    padding-left: 20px;
  }
  /deep/ .much-text{
    .el-form-item__content{
        line-height: 44px;
    }
    .el-form-item__label{
        line-height: 22px;
    }
  }
.bzcp{
    margin-left: 10px;
    border-radius: 4px;
    height: 30px;
    border: 1px solid #DCDFE6;
    color: #606266;
    padding-left: 6px;
    .slelct-native-input{
     margin-left: 10px;
    outline: none;
    border: none;
    width: 30px;
    height: 30px;
    color: #606266;
  }
}
.foot{
    display: flex;
    justify-content: right;
    height: 100px;
    background-color: #fff;
    padding-right: 60px;
}
/deep/ .small-select-type{
    width: 30px;
    .el-input__inner{
        width: 100%;
    }
}

// /deep/ .number-input.el-input-number.el-input-number--small.is-controls-right{
//     width: 84%;
// }
/deep/ .number-small-input{
    width: 100%;
    .el-input__inner{
        padding-right: 35px;
    }
}
</style>